// extracted by mini-css-extract-plugin
export default {"carousel":"BannerCarrosel_carousel__MKGo9","image":"BannerCarrosel_image__y2J1E","h2":"BannerCarrosel_h2__nMPN9"};